/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.24.0
 * @since 1.24.0
 */

import TableCellLinkTooltipText from './LinkTooltipText';

export { TableCellLinkTooltipText };
